import moment from "moment-jalaali";
import React, { useEffect, useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Loader from "react-loader-spinner";
import { connect } from "react-redux";
import {
  TelegramIcon,
  TelegramShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  EmailShareButton,
  EmailIcon,
} from "react-share";
import { toast } from "react-toastify";
import { ReactComponent as Copy } from "../../assets/icons/copy.svg";
import { ReactComponent as Eye } from "../../assets/icons/eye.svg";
import { ReactComponent as LOGO } from "../../assets/icons/Group 1.svg";
import { ReactComponent as Share } from "../../assets/icons/share.svg";
import { ReactComponent as SMS } from "../../assets/icons/sms.svg";
import InnerHeader from "../../Components/Common/InnerHeader";
import Companies from "../../Components/Home/Company";
import { ApiCall } from "../../Redux/Actions/ApiCall";
import { urls } from "../../Utils/url";
export const CompanyImage = (companyId) => {
  switch (companyId) {
    case 1:
      return require("../../assets/images/Water.png");
    case 2:
      return require("../../assets/images/Gas.png");
    case 3:
      return require("../../assets/images/Electricity.png");
    case 4:
      return require("../../assets/images/MCI.png");
    case 5:
      return require("../../assets/images/Telephone.png");
    default:
      break;
  }
};
const CompanyText = (companyId, data) => {
  switch (companyId) {
    case 1:
      return data.info.CustomerName || data.info.OwnerName;
    case 2:
      return data.info.CustomerName || data.info.OwnerName;
    case 3:
      return data.info.CustomerName || data.info.OwnerName;
    case 4:
      return "همراه اول";
    case 5:
      return "تلفن ثابت";
    default:
      break;
  }
};

export const getHistory = (setHistory, token, setLoading) => {
  ApiCall(
    "get",
    `${urls.getHistory}`,
    null,
    "getHistory",
    token,
    function (e) {
      setHistory(e.data);
      setLoading(false);
      // window.scrollTo({
      //   top: document.getElementById("paymentsContainer").offsetTop,
      //   behavior: "smooth"
      // });
    },
    function (error) {
      setLoading(false);
    }
  );
};

const ProfileInfo = ({ name, text, ltr }) => {
  return (
    <div>
      <span style={{ direction: ltr ? "ltr" : "rtl" }}>{text}</span>
      <span>{name}</span>
    </div>
  );
};

export const ShareModal = ({ shareURL, setVisible }) => {
  return (
    <div className="LoginContainer">
      <div className="ShareModal">
        <span>برنامه مورد نظر برای اشتراک گذاری را انتخاب نمایید</span>
        <div
          style={{
            width: "80%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-evenly",
          }}
        >
          <a href={`sms:?&body=${shareURL}`}>
            <SMS />
          </a>
          <TelegramShareButton
            url={shareURL}
            children={<TelegramIcon round={true} />}
          />
          <WhatsappShareButton
            url={shareURL}
            children={<WhatsappIcon round={true} />}
          />
          <EmailShareButton
            url={shareURL}
            children={<EmailIcon round={true} />}
          />
        </div>
        <div
          className="LoginButton DismissBtn"
          onClick={() => setVisible(false)}
        >
          انصراف
        </div>
      </div>
    </div>
  );
};

const PaymentComponent = ({
  name,
  cost,
  billId,
  date,
  companyId,
  trace,
  period,
  link,
  cardNum,
  index,
}) => {
  const periodFunc = () => {
    if (period == 0) {
      return "میان دوره";
    } else {
      return "پایان دوره";
    }
  };
  const [copied, setCopied] = useState(false);
  const [share, setShare] = useState(false);
  useEffect(() => {
    if (copied) {
      toast.success("لینک با موفقیت کپی شد", {
        position: "bottom-center",
      });
      setCopied(false);
    }
  }, [copied]);
  return (
    <div
      className={
        share ? "PaymentComponentContainerOpen" : "PaymentComponentContainer"
      }
    >
      <div className="PaymentComponentContainerInner">
        <img src={CompanyImage(companyId)} alt="" />
        <div>
          <ProfileInfo name={"نام مشترک"} text={name} />
          <ProfileInfo name={"نوع قبض"} text={periodFunc()} />
          <ProfileInfo name={"مبلغ"} text={` ${cost} ریال`} />
          <ProfileInfo name={"شناسه قبض"} text={billId} />
          <ProfileInfo name={"شماره پیگیری"} text={trace} />
          <ProfileInfo name={"تاریخ پرداخت"} text={date} />
          {cardNum && cardNum !== null && (
            <ProfileInfo name={"شماره کارت"} text={cardNum} ltr />
          )}
        </div>
      </div>

      <div className="PaymentComponentDesc">
        <LOGO />
        <span>{`کنتور، مدیریت هوشمند قبوض شرکت های خدماتی`}</span>
      </div>
      <div className="Links">
        <div
          className="LinkComponent"
          onClick={() => {
            window.open(link, "_blank");
            setShare(false);
          }}
        >
          <Eye /> <span>مشاهده لینک</span>
        </div>

        <div
          className="LinkComponent"
          onClick={() => {
            setShare(!share);
          }}
        >
          <Share /> <span>اشتراک گذاری</span>
        </div>

        <CopyToClipboard
          text={`${link}`}
          onCopy={() => {
            setCopied(true);
            setShare(false);
          }}
        >
          <div className="LinkComponent">
            <Copy /> <span>کپی لینک</span>
          </div>
        </CopyToClipboard>
      </div>

      <div
        className={share ? "ShareContainOpen" : "ShareContain"}
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-evenly",
          alignItems: "center",
        }}
      >
        <a href={`sms:?&body=${link}`}>
          <SMS />
        </a>
        <TelegramShareButton
          url={link}
          children={<TelegramIcon round={true} />}
        />
        <WhatsappShareButton
          url={link}
          children={<WhatsappIcon round={true} />}
        />
        {/* <EmailShareButton url={link} children={<EmailIcon round={true} />} /> */}
      </div>
    </div>
  );
};

function PaymentHistory({ token, isLogin }) {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [visible, setVisible] = useState(false);
  const [shareURL, setShareURL] = useState(false);
  const [companyId, setCompanyId] = useState(0);
  useEffect(() => {
    getHistory(setHistory, token, setLoading);
  }, [token]);
  useEffect(() => {
    companyId !== 0 &&
      document.getElementById("HistorySpan") &&
      window.scrollTo({
        top: document.getElementById("HistorySpan").offsetTop,
        behavior: "smooth",
      });
  }, [companyId]);
  const filteredHistory =
    history && history.filter((i) => i.user_bill.bill_company_id === companyId);
  return (
    <div className="container">
      <InnerHeader isLogin={isLogin} />
      {loading && (
        <Loader
          type="Grid"
          color={"#ec4d11"}
          width={100}
          height={100}
          style={{ marginTop: 100 }}
        />
      )}
      {!loading && (
        <>
          <h4 className="chooseBillType">نوع قبض را مشخص نمایید</h4>
          <Companies onClick={setCompanyId} selectedId={companyId} />

          {filteredHistory.length !== 0 && (
            <h4
              className="historySpan"
              id="HistorySpan"
              // style={filteredHistory.length === 0 && { color: "white" }}
            >
              سوابق پرداخت
            </h4>
          )}
        </>
      )}
      {!loading && filteredHistory.length === 0 && companyId !== 0 && (
        <div
          style={{
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            width: "100%",
          }}
        >
          <span className="historySpanEmpty">!موردی برای نمایش وجود ندارد</span>
        </div>
      )}
      {!loading && filteredHistory.length !== 0 && (
        <>
          <div className="paymentsContainer" id="paymentsContainer">
            {filteredHistory.map((i, index) => {
              const billInfo = i.user_bill;
              return (
                <PaymentComponent
                  setVisible={setVisible}
                  setShareURL={setShareURL}
                  key={`#History${index}`}
                  index={index}
                  name={billInfo.parameter_title}
                  cardNum={i.card_number}
                  cost={billInfo.amount.toLocaleString()}
                  link={`https://dev.mycontor.ir/Bill/${i.invoice_number}`}
                  billId={billInfo.bill_id}
                  trace={i.rrn}
                  period={billInfo.end_of_period}
                  date={moment(billInfo.paid_at).format("jD / jM /jYYYY ")}
                  companyId={billInfo.bill_company_id}
                />
              );
            })}
          </div>
        </>
      )}
      {visible && <ShareModal setVisible={setVisible} shareURL={shareURL} />}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    isLogin: state.auth.isLogin,
  };
};

export default connect(mapStateToProps)(PaymentHistory);
